export type DeviceTemplateShape = "rect" | "round" | "bar";

export interface DeviceTemplate {
  key: string;
  label: string;
  shapeType: DeviceTemplateShape;
  defaultWidth: number;
  defaultHeight: number;
  defaultCapacity: number;
}

// 平板/web 顯示全部範本；手機版用 compactDeviceTemplates（前 4 項）
export const deviceTemplates: DeviceTemplate[] = [
  { key: "square", label: "方形", shapeType: "rect", defaultWidth: 80, defaultHeight: 80, defaultCapacity: 2 },
  { key: "round", label: "圓形", shapeType: "round", defaultWidth: 90, defaultHeight: 90, defaultCapacity: 4 },
  { key: "long", label: "長形", shapeType: "rect", defaultWidth: 140, defaultHeight: 80, defaultCapacity: 6 },
  { key: "bar", label: "吧檯型", shapeType: "bar", defaultWidth: 160, defaultHeight: 56, defaultCapacity: 3 },
  { key: "booth", label: "卡座型", shapeType: "rect", defaultWidth: 120, defaultHeight: 90, defaultCapacity: 4 },
];

export const compactDeviceTemplates: DeviceTemplate[] = deviceTemplates.slice(0, 4);

export function getDeviceTemplate(key: string | null | undefined): DeviceTemplate | undefined {
  if (!key) return undefined;
  return deviceTemplates.find((t) => t.key === key);
}
